import { useEffect, useState } from "react";
import { Card } from "./../../components/card/card.jsx";
import Pagination2 from "../../components/pagination/pagination2.jsx";
import { Link, useNavigate } from "react-router-dom";
import DateTimeFormat from "../../components/dateFormater/dateFormat2.js";
import ModalEventQr from "../../components/modal/modalEventQr.jsx";
import ModalConfirm from "../../components/modal/modalConfirm.jsx";
import { eventQuestDeleteEvt, eventQuestList } from "../../config/apiSPA.js";
import { getDuration } from "../../components/durationCalculator/durationCalculator.js";

const trainingPresetData = {
  current_page: "",
  data: [],
  first_page_url: "",
  from: "",
  last_page: "",
  last_page_url: "",
  links: [],
  next_page_url: "",
  path: "",
  per_page: 3,
  prev_page_url: "",
  to: "",
  total: "",
};

function EventData() {
  const [eventListData, setEventListData] = useState(trainingPresetData);
  const [search1Value, setSearch1Value] = useState("");
  const [miniResume, setMiniResume] = useState(null);
  const [questBaseUrl, setQuestbaseUrl] = useState("");
  const [modalQrCode, setModalQrCode] = useState({ show: false, data: "" });
  const [modalDeleteEvent, setModalDeleteEvent] = useState({ show: false, id: null });

  const loadData = (data) => {
    setEventListData(data.data);
    setQuestbaseUrl(data.question_baseUrl);
  };
  const elapsed = (validUntil) => {
    const now = new Date();
    const valid = new Date(validUntil);
    if (now < valid) return true;
    return false;
  };

  function nextClick1(val) {
    if (eventListData.current_page < eventListData.last_page) eventQuestList(search1Value, eventListData.current_page + 1).then((res) => loadData(res));
  }
  function prevClick1(val) {
    if (eventListData.current_page > 0) eventQuestList(search1Value, eventListData.current_page - 1).then((res) => loadData(res));
  }
  function submitSearch1(e) {
    e.preventDefault();
    eventQuestList(search1Value).then((res) => loadData(res));
  }

  function handleQrCodeClick(link) {
    setModalQrCode({ show: true, data: link });
  }

  function handleDeleteEventClick(id) {
    setModalDeleteEvent({ show: true, id: id });
  }
  function handleDeleteConfirmClick(id) {
    setModalDeleteEvent({ show: false, id: id });
    eventQuestDeleteEvt(id, search1Value).then((res) => loadData(res));
  }

  useEffect(() => {
    eventQuestList().then((res) => loadData(res));
  }, []);

  return (
    <>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="#/">QUESTIONS</a>
              </li>
              <li className="breadcrumb-item active">Event</li>
            </ul>

            <h1 className="page-header">
              Event List <small></small>
            </h1>
          </div>
        </div>

        <hr className="mb-4" />
        {miniResume ? (
          <div className="mb-md-4 mb-3 d-md-flex">
            {/* <div className="mt-md-0 mt-2"><a href="#/" className="text-inverse text-opacity-75 text-decoration-none"><i className="fa fa-download fa-fw me-1 text-theme"></i> Export</a></div> */}
            <div className="ms-md-4 mt-md-0 mt-2">
              <i className="fas fa-user-plus fa-fw fa-lg me-1 text-theme"></i> {miniResume.monthly.new.qty + " Monthly"}
            </div>
            <div className="ms-md-4 mt-md-0 mt-2">
              <i className="fas fa-user-times user-times fa-lg me-1 text-danger"></i> {miniResume.monthly.out.qty + " Monthly"}
            </div>
            <div className="ms-md-4 mt-md-0 mt-2">
              <i className="fas fa-user-plus fa-fw fa-lg me-1 text-theme"></i> {miniResume.yearly.new.qty + " Yearly"}
            </div>
            <div className="ms-md-4 mt-md-0 mt-2">
              <i className="fas fa-user-times user-times fa-lg me-1 text-danger"></i> {miniResume.yearly.out.qty + " Yearly"}
            </div>
          </div>
        ) : (
          ""
        )}
        <Card>
          <div className="tab-content p-4">
            {/* ----------------All Tab------------------------------------------------------------------ */}
            <div className="tab-pane fade show active" id="allTab">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group mb-4">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="Search" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>

              {/* ----------------Table-------------- */}

              <div className="table-responsive">
                <table className="table table-hover text-nowrap">
                  <thead>
                    <tr>
                      <th className="border-top-0 pt-0 pb-2"></th>
                      <th className="border-top-0 pt-0 pb-2">Title</th>
                      <th className="border-top-0 pt-0 pb-2">Creator</th>
                      <th className="border-top-0 pt-0 pb-2">Link Duration</th>
                      <th className="border-top-0 pt-0 pb-2">Valid Until</th>
                      <th className="border-top-0 pt-0 pb-2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {eventListData.data.length > 0 ? (
                      eventListData.data.map((value, index) => (
                        <tr key={index}>
                          <td className="align-middle">{value.timer > 0 && <i className="text-danger far fa-clock" title="This event runs using a timer"></i>}</td>
                          <td className="align-middle">
                            <Link to={"/question/event-detail/" + value.id}>{value.judul}</Link>
                          </td>
                          <td className="align-middle">{value.user.name}</td>

                          <td className={elapsed(value.validUntil) ? "align-middle" : "align-middle text-danger"}>{getDuration(value.updated_at, value.validUntil)}</td>
                          <td className="align-middle">{DateTimeFormat(value.validUntil)}</td>
                          <td className="align-middle">
                            <a onClick={() => handleQrCodeClick(questBaseUrl + value.eventCode)} href="#/" className="btn btn-outline-default btn-sm mx-1">
                              <i className="fas fa-link text-theme"></i>
                            </a>
                            <a onClick={() => handleDeleteEventClick(value.id)} href="#/" className="btn btn-outline-default btn-sm">
                              <i className="fas fa-trash-alt text-danger"></i>
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="align-middle">no Data</td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                        <td className="align-middle"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* ----------------End Table-------------- */}

              {eventListData.data.length > 0 ? <Pagination2 pageInfo={eventListData} nextClick={(val) => nextClick1(val)} prevClick={(val) => prevClick1(val)} /> : ""}
            </div>
            {/* ----------------End All Tab------------------------------------------------------------------ */}
          </div>
        </Card>
      </div>
      <ModalEventQr show={modalQrCode.show} data={modalQrCode.data} onHide={() => setModalQrCode({ ...modalQrCode, show: false })} submitClick={() => setModalQrCode({ ...modalQrCode, show: false })} />
      <ModalConfirm
        clicked={(id) => handleDeleteConfirmClick(id)}
        show={modalDeleteEvent.show}
        id={modalDeleteEvent.id}
        onHide={() => setModalDeleteEvent({ ...modalDeleteEvent, show: false })}
        theme={"danger"}
        text={"Are you sure want to delete this event ??"}
        title={"Warning"}
      />
    </>
  );
}

export default EventData;
